import type { DogBreederLastConnectedTypeEnum } from '@gql/graphql';

export interface ApplicationsSuggestionRowItemData {
  id: number;
  name: string;
  link: string;
  image: string;
  lastConnectedBadgeType?: DogBreederLastConnectedTypeEnum;
  breedId: number;
  breedName: string;
  pedigree: string;
}

export interface ApplicationsSuggestionTableData {
  rows: ApplicationsSuggestionRowItemData[];
  showSkipButton?: boolean;
  canSubmit?: boolean;
  isSubmitting?: boolean;
  onSuggestedBreederClick(breederId: number): void;
}

export interface ApplicationsSuggestionTableProps extends ApplicationsSuggestionTableData {}
